module.exports = __webpack_public_path__ + "img/stand_luoluo_1_cut.59199883.png";